import React from 'react';
import './ListFooter.css'; // 스타일링을 위한 CSS 파일을 임포트합니다.

const ListFooter = ({ page, totalPages, showPageNum, handlePageChange }) => {
  if (showPageNum === undefined) showPageNum = 10;
  else if (typeof showPageNum === "string") showPageNum = parseInt(showPageNum);
  
  const getStartPage = () => {
    return Math.floor((page - 1) / showPageNum) * showPageNum + 1;
  };

  const getStopPage = () => {
    return Math.min(getStartPage() + showPageNum - 1, totalPages);
  };

  const startPage = getStartPage();
  const stopPage = getStopPage();

  console.log(`[ListFooter] page: ${page}, totalPages: ${totalPages}, startPage: ${startPage}, stopPage: ${stopPage}`);

  return (
    <div className="paging">
      {/* 첫 페이지가 아닐 때만 First, Prev 버튼 표시 */}
      {page > 1 && (
        <button
          onClick={() => handlePageChange(1)}
        >
          First
        </button>
      )}
      {startPage > 1 && (
        <button
          onClick={() => handlePageChange(startPage - 1)}
        >
          Prev
        </button>
      )}
      
      {/* 페이지 번호들 - getStartPage()부터 getStopPage()까지만 표시 */}
      {Array.from({ length: stopPage - startPage + 1 }, (_, index) => {
        const pageNumber = startPage + index;
        return (
          page === pageNumber ? (
            <strong key={pageNumber}>
              {pageNumber}
            </strong>
          ) : (
            <button
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
            >
              {pageNumber}
            </button>
          )
        );
      })}
      
      {/* 마지막 페이지가 아닐 때만 Next, Last 버튼 표시 */}
      {stopPage < totalPages && (
        <button
          onClick={() => handlePageChange(stopPage + 1)}
        >
          Next
        </button>
      )}
      {/* Last 버튼: 반복문의 마지막 페이지(stopPage)와 전체 마지막 페이지(totalPages)가 다를 때만 표시 */}
      {stopPage < totalPages && (
        <button
          onClick={() => handlePageChange(totalPages)}
        >
          Last
        </button>
      )}
    </div>
  );
};

export default ListFooter;